import React, { useState } from "react";
import Media from "react-media";
import { Accordion, Card, Image } from "react-bootstrap";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import moment from "moment";
import ActiveDeactiveEventsAndOffers from "../../reusableComponents/allPopupReusable/offerEventPopup/ActiveDeactiveEventsAndOffers";
import MobileSuperAdminDeleteEvent from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/MobileSuperAdminDeleteEvent";
import MobileVendorEditOfflineEvent from "./EditEvent/MobileVendorEditOfflineEvent";
import MobileVendorEditOnlineEvent from "./EditEvent/MobileVendorEditOnlineEvent";
import MobileViewEventDetailsOffline from "./MobileViewEventDetailsOffline";
import MobileViewEventDetailsOnline from "./MobileViewEventDetailsOnline";
import  SuperAdminDeleteEvent  from "../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteEvent";
import { PopupActionButton } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NavLink } from "react-router-dom";
import ViewEventDetailsOnline from "./ViewEventDetailsOnline";
import { SET_ONLINE_EVENT_DETAILS_VENDOR } from "../../../store/types";
import ReadMoreReact from "read-more-react";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const EventMobile = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const editOfflineEvent = (data) => (e) => {
    history.push({
      pathname: `/event/edit-offline-event`,
      state: { editData: data },
    });
  };

  const editOnlineEvent = (data) => (e) => {
    history.push({
      pathname: `/event/edit-online-event`,
      state: { editData: data },
    });
  };
  //state
  const [show, setShow] = useState(false);

  const viewOfflineEventAction = (id) => {
    history.push({
      pathname: `/offline-events-details/${id}`,
      state: { offlineEventInformation: id },
    });
  };

  const viewOnlineEventAction = (data) => {
    history.push({
      pathname: `/online-event-details/${data._id}`,
      state: { onlineEventInformation: data },
    });
    dispatch({
      type: SET_ONLINE_EVENT_DETAILS_VENDOR,
      payload: data,
    });
  };

  return (
    <React.Fragment>
      <div className=" ">
        <SwipeableList className={`events-mobile-swipablescreens `}>
          {({ swipeOffer, ...rest }) => (
            <div className={`${show ? "events-mobile-swipablescreens" : ""}`}>
              <SwipeableListItem
                swipeLeft={{
                  content: (
                    <div className="d-flex swipeOption">
                      {props.data.isOnline ? (
                        <button
                          onClick={() => viewOnlineEventAction(props.data)}
                          className="enViewDashboard btn "
                        >
                          <Image
                            src={require("../../../assets/images/ActionImages/image/onboarding.svg")}
                            alt="View"
                            title="View"
                            fluid
                            className="mr-2"
                          />
                          <div className="f12-500">View Dashboard</div>
                        </button>
                      ) : (
                        <button
                          onClick={() => viewOfflineEventAction(props.data._id)}
                          className="enViewDashboard btn"
                        >
                          <Image
                            src={require("../../../assets/images/ActionImages/image/onboarding.svg")}
                            alt="View"
                            title="View"
                            fluid
                            className="mr-2"
                          />
                          <div className="f12-500">View Dashboard</div>
                        </button>
                      )}
                      {/* <NavLink to="/offline-events-details">
                        <PopupActionButton
                          buttonText={
                            <div className="f10-400">View Dashboard</div>
                          }
                          buttonType="button"
                          buttonClass="bigbuttongray"
                          style={{background : "#F0F0F0"}}
                          // onClick={onOpenModal}
                        />
                      </NavLink> */}
                      <MobileViewEventDetailsOffline
                        mobileButton={true}
                        vendorEvent={props.data}
                      />
                      {/* <MobileViewEventDetailsOnline
                      mobileButton={true}
                      vendorEvent={props.data}
                    /> */}
                      <MobileSuperAdminDeleteEvent
                        actionBy={"vendor"}
                        eventId={props.data._id}
                      />
                      {/* <MobileVendorEditOnlineEvent
                      mobileButton={true}
                      data={props.data}
                    /> */}
                      {/* <MobileVendorEditOfflineEvent
                        mobileButton={true}
                        data={props.data}
                      /> */}
                      <button
                        type="button"
                        className="n_button_d_status font_18_m "
                        style={{ backgroundColor: "#37AC1E", color: "white" }}
                        onClick={
                          props.data && props.data.isOnline
                            ? editOnlineEvent(props.data)
                            : editOfflineEvent(props.data)
                        }
                      >
                        Edit
                      </button>
                    </div>
                  ),
                  action: () => setShow(true),
                }}
                swipeRight={{
                  // content: <div>Revealed content during swipe</div>,
                  action: () => setShow(false),
                }}
                {...rest}
              >
                <Card className="main-reusable-accordion">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey={props.indexKey + 1}
                  >
                    <div className="d-flex align-items-center">
                      <div className="col-7 d-flex align-items-center">
                        <div
                          className="text-center d-flex flex-column align-items-center"
                          style={{ width: "20%" }}
                        >
                          <SimpleReactLightbox>
                            <SRLWrapper options={options}>
                              <div className="enIMG33 rounded">
                                <Image
                                  src={
                                    props.data.photo_thumbnails &&
                                    props.data.photo_thumbnails.length
                                      ? props.data.photo_thumbnails[0]
                                      : props.data.photos[0]
                                  }
                                  alt="View"
                                  title="View"
                                  className="w-100 h-100"
                                />
                              </div>
                            </SRLWrapper>
                          </SimpleReactLightbox>
                          {props?.data?.isOnline ? (
                            <div className="enSuccessLBL mt-2">Online</div>
                          ) : (
                            <div className="enPendingLBL mt-2">Offline</div>
                          )}
                          {/* enSuccessLBL */}
                        </div>
                        <div className="pl-3">
                          <div className="f10-700">{props.data.name}</div>
                          {/* <div className="f9-400">{props.data.description}</div> */}
                          <div id="read-more-text" className="f9-400">
                            <ReadMoreReact
                              text={props.data && props.data.description}
                              min={0}
                              ideal={0}
                              max={props.data && props.data.description.length}
                              readMoreText={"Read More"}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-3 px-0">
                        <div className="f12-500">
                          {moment(props.data.start_date).format("Do MMM YYYY")}
                        </div>
                        <div className="f12-500 pl-4 py-1">to</div>
                        <div className="f12-500 text-red">
                          {moment(props.data.end_date).format("Do MMM YYYY")}
                        </div>
                      </div>
                      <div
                        className="col-2"
                        onClick={(e) => {
                          if (!e) var e = window.event;
                          e.cancelBubble = true;
                          if (e.stopPropagation) e.stopPropagation();
                        }}
                      >
                        <ActiveDeactiveEventsAndOffers
                          diameter={17}
                          height={10}
                          width={30}
                          activeProps={props.data}
                          displayActive={true}
                          actionButton="events"
                        />
                      </div>
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={props.indexKey + 1}>
                    <Card.Body>
                      <div className="d-flex border-top">
                        {props?.data?.isOnline && (
                          <>
                            <div className="col-3 py-2 border-right">
                              <div className="f10-700">Coupon Code</div>
                              <div className="f10-500">
                                {props.data.coupon_code}
                              </div>
                            </div>
                            <div className="col-3 py-2 border-right">
                              <div className="f10-700">Hyperlink</div>
                              <div className="f10-500 enEllips">-</div>
                            </div>
                            <div className="col-3 py-2 border-right">
                              <div className="f10-700">Event Code</div>
                              <div className="f10-500enEllips">-</div>
                            </div>
                          </>
                        )}
                        <div className="col-3 py-2">
                          <div className="f10-700 pb-2">Primary</div>
                          <div
                            onClick={(e) => {
                              if (!e) var e = window.event;
                              e.cancelBubble = true;
                              if (e.stopPropagation) e.stopPropagation();
                            }}
                          >
                            <ActiveDeactiveEventsAndOffers
                              diameter={17}
                              height={10}
                              width={30}
                              activeProps={props.data}
                              displayPrimary={true}
                              actionButton="events"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex border-top">
                        <div className="col-6 py-2 border-right">
                          <div className="f10-700">Venue</div>
                          <div className="f10-500">
                            {props.data.venue_address}
                          </div>
                        </div>
                        <div className="col-6 py-2">
                          <div className="f10-700">Timing</div>
                          <div className="f10-500">
                            {moment(props.data.start_date).format("hh:mm A")}-
                            {moment(props.data.end_date).format("hh:mm A")}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex pt-2 border-top align-items-center">
                        {props.data && props.data.isOnline ? (
                          <MobileViewEventDetailsOnline
                            vendorEvent={props.data}
                          />
                        ) : (
                          <MobileViewEventDetailsOffline
                            vendorEvent={props.data}
                          />
                        )}
                        <div
                          className="enIconBtn mr-3"
                          onClick={
                            props.data && props.data.isOnline
                              ? editOnlineEvent(props.data)
                              : editOfflineEvent(props.data)
                          }
                        >
                          <Image
                            src={require("../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div>
                        {/* <MobileVendorEditOnlineEvent /> */}
                        <SuperAdminDeleteEvent
                          actionBy={"vendor"}
                          eventId={props.data._id}
                        />
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </SwipeableListItem>
            </div>
          )}
        </SwipeableList>
      </div>
    </React.Fragment>
  );
};
